export default __webpack_public_path__ + "static/media/icon-insights-va.c8369486.svg";